import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpGeoSelect} from '@features/settings/http/settings.http.ts'
import {z} from 'zod'
import {captureException} from '@sentry/react'

export const useCountries = ({region}: {region: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.GEO_SELECT, region],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGeoSelect({params: {region}}),
                responseShape: z.object({
                    countries: z.array(
                        z.object({
                            country: z.string().min(1),
                            extended_country: z.string().min(1)
                        })
                    )
                }),
                onZodError: captureException
            })
    })
